export const SERP_FEATURE_BADGES = ['featured_snippet', 'people_also_ask', 'ai_overview'] as const;
export type SerpFeatureBadge = typeof SERP_FEATURE_BADGES[number];

export const SERP_FEATURE_ICONS: Record<SerpFeatureBadge, string> = {
    featured_snippet: 'format_quote',
    people_also_ask: 'help_outline',
    ai_overview: 'auto_awesome',
};

function asRecord(value: unknown): Record<string, unknown> {
    return value && typeof value === 'object' ? value as Record<string, unknown> : {};
}

export function serpItemTypesOf(keyword: Record<string, unknown> | null | undefined): string[] {
    const row = asRecord(keyword);
    const info = asRecord(row.serp_info);
    const nested = asRecord(asRecord(row.keyword_data).serp_info);
    const types = Array.isArray(info.serp_item_types)
        ? info.serp_item_types
        : (Array.isArray(nested.serp_item_types) ? nested.serp_item_types : []);
    return types.map((item) => String(item || '')).filter(Boolean);
}

export function serpFeatureBadges(keyword: Record<string, unknown> | null | undefined): SerpFeatureBadge[] {
    const types = new Set(serpItemTypesOf(keyword));
    return SERP_FEATURE_BADGES.filter((id) => types.has(id));
}

export function keywordAiVolume(keyword: Record<string, unknown> | null | undefined): number | null {
    const row = asRecord(keyword);
    const info = asRecord(row.keyword_info);
    const volume = Number(row.ai_search_volume ?? info.ai_search_volume ?? info.ai_monthly_searches ?? row.ai_monthly_searches);
    if (!Number.isFinite(volume) || volume <= 0) {
        return null;
    }
    return volume;
}

export function keywordAnswerHint(keyword: Record<string, unknown> | null | undefined): string {
    const row = asRecord(keyword);
    return String(row.answerHint || '').replace(/\s+/g, ' ').trim();
}
